/* global SERVER_BASE_URL */
import useFetch from 'use-http'

const useApi = () => useFetch(SERVER_BASE_URL)

export default useApi
